export default "__VITE_ASSET__Daba2EG7__"